const prepareSave = (data, token) => {
  const tenant = { ...data }
  tenant.password_confirmation = tenant.password
  tenant.country_register = tenant.country_register.replace('-', '')
  tenant.genre = tenant.genre.id
  tenant.token = token
  return tenant
}

export default {
  doActive () {
    this.$v.$touch()
    if (this.$v.$error) {
      this.errorTrue = true
      return
    }

    this.$http.post('/v1/auth/active/account/tenant', prepareSave(this.tenant, this.token))
    .then(({data}) => {
      if (data) {
        return this.$router.push({name: 'auth.login'})
      }
    })
    .catch(({data}) => {
      this.errors = data
    })
  },
  getTenantInfo (token) {
    if (token === null) {
      return
    }
    this.isLoading = true
    this.$http.post('/v1/auth/active/tenant', {token: token})
      .then((data) => {
        this.tenant = data.user
      })
      .catch(({data, meta}) => {
      })
  },
  setGenre () {

  },
  doShow () {
    this.isShowing = true
  },
  doHide () {
    this.isShowing = false
  },
  internalRegulation (status) {
    if (status) {
      this.tenant.internal_regulation = false
    } else {
      this.tenant.internal_regulation = true
    }
  },
  getToken (token) {
    this.token = token
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/active/tenant/resources/methods.js